module.exports = require('./lib/speakingurl');



//////////////////
// WEBPACK FOOTER
// /~/speakingurl/index.js
// module id = 380
// module chunks = 0